// Angular
import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Angular Material / CDK
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './password-delete-dialog.component.html',
  styleUrl: './password-delete-dialog.component.scss',
  imports: [MatButtonModule, MatCheckboxModule, FormsModule, NgClass],
})
export class PasswordDeleteDialogComponent implements OnInit {
  public dialog = inject(MatDialogRef<PasswordDeleteDialogComponent>);

  constructor() {
    this.dialog.disableClose = true;
  }

  readonly words: readonly string[] = [
    'bamboozle',
    'kerfuffle',
    'skedaddle',
    'flabbergasted',
    'snickerdoodle',
    'gobbledygook',
    'shenanigans',
    'hootenanny',
    'fiddle-faddle',
    'hullabaloo',
    'whippersnapper',
    'dingbat',
    'boondoggle',
    'quickquestion',
    'zamboni',
    'bumblebee',
    'pumpernickel',
    'collywobbles',
    'lollygag',
    'snollygoster',
    'dillydally',
    'fandango',
    'markisbald',
    'jamboree',
    'fighterjet',
  ];

  readonly confirmationWord = signal('');
  readonly doesConfirmationMatch = signal(false);
  readonly isUsersSelected = signal(false);
  readonly isCrewSelected = signal(false);

  readonly isButtonEnabled = computed(
    () => this.doesConfirmationMatch() && (this.isUsersSelected() || this.isCrewSelected()),
  );

  ngOnInit(): void {
    this.confirmationWord.set(this.words[Math.floor(Math.random() * this.words.length)]);
  }

  onInput(text: string) {
    this.doesConfirmationMatch.set(text === this.confirmationWord());
  }

  deletePasswords() {
    const orgUsersPasswordDeleteDTO = {
      includeUsers: this.isUsersSelected(),
      includeCrew: this.isCrewSelected(),
    };
    this.dialog.close(orgUsersPasswordDeleteDTO);
  }
}
